
import { useState } from 'react';
import { createTestSuggestion, createDirectSuggestion } from '@/utils/suggestions';

export const useDebugMode = (fetchSuggestions: () => Promise<void>) => {
  const [isDebugMode, setIsDebugMode] = useState(false);

  const toggleDebugMode = () => {
    setIsDebugMode(!isDebugMode);
  };

  const handleCreateTestSuggestion = async () => {
    await createTestSuggestion();
    // Wait a moment for the realtime subscription to pick up the new suggestion
    setTimeout(fetchSuggestions, 1000);
  };

  const handleCreateDirectSuggestion = async () => {
    await createDirectSuggestion();
    // Wait a moment for the realtime subscription to pick up the new suggestion
    setTimeout(fetchSuggestions, 1000);
  };

  return {
    isDebugMode,
    toggleDebugMode,
    handleCreateTestSuggestion,
    handleCreateDirectSuggestion
  };
};
